// Dependencies
import React, { Component } from 'react';

// Primereact imports
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Styling
import './good-standing.scss';

// Utils
import { WORLD_LIST } from '../../../common/lists/countries';
import { PRODUCT_KEY_COUNTRY } from '../../../common/constants';

// Redux
import { updateBasket } from '../../../redux/actions/order';
import { connect } from 'react-redux';

class GoodStandingComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            country: null,
            validCountry: true
        }
    }

    updateFormComponent(column, value) {
        this.setState({
            [column]: value
        })
    }

    submitAcquisition() {
        if(this.validateForm()) {
            let metadata = [
                { key: PRODUCT_KEY_COUNTRY, value: this.state.country.code }
            ];

            // Add product to basket
            let product = this.props.product;
            product.metadata = metadata;
            product.title = this.props.t("products.products." + product.title) + " - " + this.state.country.code;
            
            let products = [];

            for (let i = 0; i < this.props.basketProducts.length; i++) {
                products.push(this.props.basketProducts[i]);
                
            }

            products.push(product);

            this.props.updateBasket(products, this.props.basketTrainings);
            this.props.onClose();
        }
    }

    validateForm() {
        this.setState({
            validCountry: this.state.country !== null
        });

        let validationResult = (this.state.country !== null);

        return validationResult;
    }

    render() {

        return (
            <div className="grid mgt-10">
                <div className="col-12" style={{fontSize: "14px"}}>
                    <b>{this.props.t("products.labels.info-note")}</b>
                </div>
                <div className="col-12" style={{textAlign: "justify"}}>
                    <ul style={{marginLeft: "20px", padding: 0}}>
                        <li style={{marginBottom: "10px"}}>{this.props.t("products.labels.good-standing")}</li>
                        <li>{this.props.t("products.labels.digital-document")}</li>
                    </ul>
                </div>
                <div className="col-12" style={{fontSize: "14px"}}>
                    <b>{this.props.t("products.labels.product-form")}</b>
                </div>
                <div className="col-12">
                    <div className="flex flex-column gap-2">
                        <label htmlFor="country">{this.props.t("products.labels.country")}</label>
                        <Dropdown id="country" value={this.state.country} options={WORLD_LIST} optionLabel="name" onChange={(evt) => this.updateFormComponent("country", evt.value)}></Dropdown>
                        { this.state.validCountry ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                    </div>
                </div>
                <div className='col-12 t-align-right'>
                    <div className="flex flex-wrap justify-content-end gap-2">
                        <Button label={this.props.t("products.labels.add")} icon="pi pi-shopping-cart" onClick={(evt) => this.submitAcquisition() } />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        basketProducts: state.store.basketProducts,
        basketTrainings: state.store.basketTrainings
    } 
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateBasket: (basketProducts, basketTrainings) => { dispatch(updateBasket(basketProducts, basketTrainings)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(GoodStandingComponent));